import { render } from "./DashboardViewSelector.vue?vue&type=template&id=7e5b2c80"
import script from "./DashboardViewSelector.vue?vue&type=script&lang=js"
export * from "./DashboardViewSelector.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__